import { mapGetters, mapActions } from 'vuex'

import MainButton from '@/components/MainButton/index'
import ResponseDialog from '@/components/ResponseDialog/index'

import { getAllCountries } from '@/utils/locationHelpers'
import { objectToFormData } from '@/utils/formDataTransformer'

export default {
  name: 'EditProfile',
  components: {
    MainButton,
    ResponseDialog
  },
  data: () => ({
    countries: null,
    editProfileForm: false,
    firstName: '',
    lastName: '',
    country: '',
    username: '',
    firstNameRules: [v => !!v || 'First name is required'],
    lastNameRules: [v => !!v || 'Last name is required'],
    countryRules: [v => !!v || 'Country is required'],
    usernameRules: [
      v => !!v || 'Username is required',
      v => /^\S*$/.test(v) || 'Spaces are not allowed',
      v => v.length >= 5 || 'Username should have minimum of 5 characters',
      v => v.length <= 20 || 'Max characters is 20'
    ],
    usernameCheckerRequest: null,
    usernameChecker: true,
    usernameAvailable: '',
    countryCode: '',
    continent: '',
    imageUrl: '',
    imageFile: null,
    userId: null,
    editProfileResponseDialog: false,
    dialogMessage: '',
    loading: false,
    oldThumbnail: null,
    oldAvatar: null
  }),
  computed: {
    ...mapGetters('auth', {
      userObj: 'USER_OBJ'
    }),
    ...mapGetters('profile', {
      saveEditedProfileResponse: 'SAVE_EDITED_PROFILE_RESPONSE',
      usernameAvailabilityResponse: 'USERNAME_AVAILABILITY_RESPONSE'
    })
  },
  methods: {
    ...mapActions('signup', {
      saveUserAction: 'SAVE_USER'
    }),
    ...mapActions({
      cancelAjaxRequestAction: 'CANCEL_AJAX_REQUEST'
    }),
    ...mapActions('profile', {
      saveEditedProfileAction: 'SAVE_EDITED_PROFILE',
      usernameAvailabilityAction: 'USERNAME_AVAILABILITY'
    }),
    usernameChangeAPI(val) {
      const {
        srcElement: { value }
      } = val

      if (this.usernameChange(value) === true) {
        if (this.usernameCheckerRequest) {
          this.clearUsernameRequest()
        }

        this.usernameCheckerRequest = setTimeout(() => {
          this.usernameAvailabilityAction({
            username: value
          })
        }, 1000)
      }
    },
    usernameChange(username) {
      if (username) {
        if (
          username.length >= 5 &&
          username.length <= 20 &&
          /^\S*$/.test(username)
        ) {
          return true
        } else {
          this.clearUsernameRequest()
          return 'Username must contain at least 5 characters and not more than 20 without spaces'
        }
      }
      this.clearUsernameRequest()
      return 'Username is required'
    },
    countryChange(val) {
      if (val) {
        this.countryCode = val.iso3
        this.continent = val.continent
      }
    },
    pickImage() {
      this.$refs.uploadImage.click()
    },
    onImagePicked(e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result
          this.imageFile = files[0]
        })
      }
    },
    clearUsernameRequest() {
      clearTimeout(this.usernameCheckerRequest)
      this.cancelAjaxRequestAction()
      this.usernameAvailable = ''
    },
    saveProfile() {
      if (this.$refs.editProfileForm.validate()) {
        this.loading = true
        const object = {
          id: this.userId,
          firstName: this.firstName,
          lastName: this.lastName,
          countryCode: this.countryCode,
          continent: this.continent,
          username: this.username,
          avatar: this.imageFile,
          oldAvatar: this.oldAvatar,
          oldThumbnail: this.oldThumbnail
        }
        const payload = {
          data: objectToFormData(object),
          config: {
            headers: {
              'content-type': 'multipart/form-data'
            }
          }
        }

        this.saveEditedProfileAction(payload).then(() => {
          this.loading = false
          this.editProfileResponseDialog = true
          this.dialogMessage = this.saveEditedProfileResponse.message
        })
      }
    },
    dialogResponseClick() {
      this.editProfileResponseDialog = false

      if (this.saveEditedProfileResponse.success) {
        this.$router.push({ name: 'profile' })
      }
    },
    cancelButtonClick() {
      this.$router.push({ name: 'profile' })
    }
  },
  watch: {
    usernameAvailabilityResponse(data) {
      if (data.success) {
        this.usernameAvailable = data.message
        this.usernameChecker = true
      } else {
        this.usernameAvailable = ''
        this.usernameChecker = data.message
      }
    }
  },
  created() {
    this.countries = getAllCountries()
  },
  activated() {
    const {
      id,
      firstName,
      lastName,
      username,
      countryCode,
      continent,
      avatar,
      thumbnail
    } = this.userObj
    this.imageUrl = avatar || require('@/assets/profile-avatar.svg')
    this.oldThumbnail = thumbnail
    this.oldAvatar = avatar
    this.firstName = firstName
    this.lastName = lastName
    this.username = username
    this.countryCode = countryCode
    this.country = this.countries.find(x => x.iso3 === countryCode)
    this.continent = continent
    this.userId = id
    this.$store.commit('SET_IMAGE_BACKGROUND', true)
    this.$store.commit('SET_SHOW_BOTTOM_NAV', false)
    this.$store.commit('SET_PAGE_TITLE', 'Edit Profile')
  },
  deactivated() {
    this.imageFile = null
    this.imageUrl = null
    this.$refs.editProfileForm.reset()
    this.$store.commit('SET_IMAGE_BACKGROUND', false)
    this.$store.commit('SET_SHOW_BOTTOM_NAV', true)
  }
}
